export default "__VITE_ASSET__bc7c330a__"